export const DEFAULT_ACTION = 'screen/FormChangePassScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/FormChangePassScreen/UPDATE_INPUT';

export const SUBMIT_PASSWORD = 'screen/FormChangePassScreen/SUBMIT_PASSWORD';
export const SUBMIT_PASSWORD_SUCCESS = 'screen/FormChangePassScreen/SUBMIT_PASSWORD_SUCCESS';
export const SUBMIT_PASSWORD_FAIL = 'screen/FormChangePassScreen/SUBMIT_PASSWORD_FAIL';